import { render, staticRenderFns } from "./GenericSelection.vue?vue&type=template&id=5a5ab000&"
import script from "./GenericSelection.vue?vue&type=script&lang=ts&"
export * from "./GenericSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRadio: require('/home/vsts/work/1/a/NuxtApp/components/base/Radio.vue').default})
